import { render, staticRenderFns } from "./EnrollmentCalculator.vue?vue&type=template&id=5263a52f&lang=pug"
import script from "./EnrollmentCalculator.vue?vue&type=script&lang=js"
export * from "./EnrollmentCalculator.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {DateTimeInput: require('/home/docker/code/frontend/components/DateTimeInput.vue').default})
